import { useState } from "react";
import { ITask } from "../../../data_models/task";
import Lightbox from "../../common/Lightbox";
import { FilledButton, OutlinedButton } from "../../common/Button";

import useDisplayNotifications from "../../../hooks/useDisplayNotifications";
import { DisplayNotificationType } from "../../../models/DisplayNotification";
import useProjectManagement from "../../../hooks/useProjectManagement";

interface UnassignFreelancerLightboxProps {
    onClose: () => void;
    task: ITask;
    onUpdateTask: (updatedTask: ITask) => void;
}

const UnassignFreelancerLightbox: React.FC<UnassignFreelancerLightboxProps> = ({ onClose, task, onUpdateTask }) => {

    const [loading, setLoading] = useState(false);

    const { unassignFreelancer } = useProjectManagement();
    const { addNotification } = useDisplayNotifications();

    const onUnassign = async () => {
        try {
            setLoading(true);
            const result = await unassignFreelancer(task._id!);
            if (result) {
                onUpdateTask(result.task);
            }

        } catch (error: any) {
            addNotification({
                message: error.message,
                type: DisplayNotificationType.ERROR
            });
        } finally {
            setLoading(false);
            onClose();
        }
    }
    return (

        <Lightbox
            header="Unassign Talent"
            onClose={onClose}
            onCancel={onClose}
            onConfirm={onUnassign}
            confirmText="Unassign"
            confirmTheme="danger"
            loadingConfirm={loading}
            content={
                <p>You can unassign a talent from a task if they’re unresponsive or not delivering as expected. They won’t be paid for uncompleted work. After unassigning, you’ll be able to assign a new talent and keep things moving!</p>
            }
        />

    );
}

export default UnassignFreelancerLightbox;